const getters = {
  IsMobile: state => state.baseInfo.IsMobile,
  RoateUser: state => state.baseInfo.RoateUser,
  Download: state => state.baseInfo.Download,
  Interact: state => state.baseInfo.Interact,
  CanChangeText: state => state.baseInfo.CanChangeText,
  MettingData: state => state.baseInfo.MettingData,
  UserOrder: state => state.baseInfo.UserOrder,
  VideoData: state => state.baseInfo.VideoData,
  UserActive: state => state.baseInfo.UserActive,
  Cookie: state => state.baseInfo.Cookie,
  LuckyNumber: state => state.baseInfo.LuckyNumber,
  InteractProess: state => state.baseInfo.InteractProess,
  CurrentVid: state => state.baseInfo.CurrentVid,

  
  Notify: state => state.chartInfo.Notify,
  activeted: state => state.chartInfo.activeted,
  UserInlie: state => state.chartInfo.UserInlie,
  conversationList: state => state.chartInfo.conversationList,
  currentUser: state => state.chartInfo.currentUser,
  currentMsgList: state => state.chartInfo.currentMsgList,
}

export default getters
